export const isNil = (value: any): boolean => {
  return value === null || value === undefined;
};
